import React, { Component } from "react";

import "../common/index.scss";

// import custom Components
import ProductListing from "./common/product-listing";
import Breadcrumb from "../common/breadcrumb";
import FilterBar from "./common/filter-bar";
import "./collection-no-sidebar.css";
import { connect } from "react-redux";
import {
  emptySearchedProductsArray,
  setSearchedProductsArray,
} from "../../actions/index";
import Axios from "axios";
import { ClipLoader } from "react-spinners";
class CollectionNoSideBar extends Component {
  state = {
    layoutColumns: 2,
    shop: "1688",
    shop_name: "",
    categoryId: "",
    searchBarValue: "",
    imageUrl: "",
    prviewImage: "",
    filterByCategory: "",
    active: false,
    imgLoading: false,
  };

  componentDidMount = () => {
    const query = new URLSearchParams(this.props.location.search);
    const shop_name = query.get("shop_name");
    const categoryId = query.get("category_id");
    const imageUrl = query.get("imageUrl");
    const savedImage = localStorage.getItem("uploadedImagePreview");
    if (savedImage) {
      this.setState({ prviewImage: savedImage });
    }
    console.log(shop_name);
    this.setState({
      shop_name,
      categoryId,
      imageUrl: imageUrl
        ? imageUrl
            .replace("rechargeRequests/", "rechargeRequests%2F")
            .replaceAll(" ", "%20")
        : "",
    });
  };
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const query = new URLSearchParams(nextProps.location.search);
    const shop_name = query.get("shop_name");
    const categoryId = query.get("category_id");
    const imageUrl = query.get("imageUrl");
    console.log(shop_name);
    const savedImage = localStorage.getItem("uploadedImagePreview");
    if (savedImage) {
      this.setState({ prviewImage: savedImage });
    }
    this.setState({
      shop_name,
      categoryId,
      imageUrl: imageUrl
        ? imageUrl
            .replace("rechargeRequests/", "rechargeRequests%2F")
            .replaceAll(" ", "%20")
        : "",
      filterByCategory: "",
    });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  handleChange2 = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      if (this.state.filterByCategory && this.state.filterByCategory !== "") {
      } else {
      }
    });
  };
  handleSearchBarSubmit = (event) => {
    event.preventDefault();
    if (this.state.searchBarValue.length < 35) {
      var win = window.open(
        `${process.env.PUBLIC_URL}/collection/${this.state.searchBarValue}`,
        "_blank"
      );
      win.focus();
    } else {
      this.props.setSearchedProductsArray(0, []);
      if (this.state.searchBarValue.includes("1688")) {
        let productId = this.state.searchBarValue.split("/")[4].split(".")[0];
        console.log(productId);

        var win = window.open(
          `${process.env.PUBLIC_URL}/product/${productId}`,
          "_blank"
        );
        win.focus();
      } else {
        let taobaoUrl = new URL(this.state.searchBarValue);
        let params = taobaoUrl.search;
        const urlParams = new URLSearchParams(params);
        const id = urlParams.get("id");
        var win = window.open(
          `${process.env.PUBLIC_URL}/product/${id}`,
          "_blank"
        );
        win.focus();
      }
    }
    this.setState({ searchBarValue: "" });
  };

  LayoutViewClicked(colums) {
    this.setState({
      layoutColumns: colums,
    });
  }

  componentWillUnmount = () => {
    // this.props.emptySearchedProductsArray();
  };

  resizeAndCompressImage = (
    file,
    maxWidth = 500,
    maxHeight = 500,
    quality = 0.7
  ) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = (e) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        let { width, height } = img;

        // Maintain aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // Compress image to JPEG format
        const compressedBase64 = canvas.toDataURL("image/jpeg", quality); // quality from 0 to 1
        resolve(compressedBase64.split(",")[1]); // remove 'data:image/jpeg;base64,'
      };

      img.onerror = (err) => {
        reject(err);
      };
    });
  };

  handleImgChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    this.setState({
      imgLoading: true,
    });

    // 👇 Get Data URL for preview (not the same as pure base64 for upload)
    const reader = new FileReader();
    reader.onload = () => {
      const imageDataUrl = reader.result; // includes "data:image/jpeg;base64,..."
      localStorage.setItem("uploadedImagePreview", imageDataUrl); // 🧠 Persist it
      this.setState({ imageUrl: imageDataUrl }); // Show it
    };
    reader.readAsDataURL(file);

    const base64 = await this.resizeAndCompressImage(file);

    console.log(base64);
    if (base64 === this.state.lastImageBase64) {
      console.log("Image is the same, skipping upload.");
      return;
    }

    this.setState({ lastImageBase64: base64 });

    const resultObj = await Axios.post("/api/products/upload-image", {
      imageBase64: base64,
    });
    console.log(resultObj);
    if (
      resultObj.data &&
      resultObj.data.result &&
      resultObj.data.result.result
    ) {
      this.setState({ imgLoading: false });
      this.openPage(resultObj.data.result.result);
    } else {
      this.setState({ imgLoading: false });
      alert("There was an error uploading your image.");
    }
  };

  openPage = (imgUrl) => {
    this.props.history.push(
      `${process.env.PUBLIC_URL}/collection/img_uploads?imageUrl=${imgUrl}`
    );
  };

  render() {
    const { id } = this.props.match.params;
    console.log(this.state.imageUrl);
    console.log(id);
    return (
      // <LoadingOverlay
      //   active={this.state.active}
      //   spinner={<ClipLoader color="#ff4a4e" size={50} />}
      // >
      // <LoadingOverlay />
      <div>
        <Breadcrumb title={id} />

        {/*Section Start*/}
        <section className="section-b-space">
          <div className="collection-wrapper">
            <div className="container">
              <div className="row">
                <div className="collection-content col remove-padding-mobie-view">
                  <div className="page-main-content">
                    <div className="container-fluid">
                      <div className="row">
                        <div
                          className="col-sm-12"
                          style={{ paddingLeft: 0, paddingRight: 0 }}
                        >
                          <div className="collection-product-wrapper">
                            <div className="product-top-filter">
                              <div className="container-fluid p-0" />
                            </div>
                            <div
                              className="top-searchbar-parent hide-searchbar-for-pc"
                              style={{ background: "white" }}
                            >
                              <div className="top-searchbar-container-2">
                                <form
                                  className="form_search top-form form-search2"
                                  role="form"
                                  onSubmit={this.handleSearchBarSubmit}
                                  style={{
                                    borderRadius: "0px",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <input
                                    id="query search-autocomplete"
                                    type="search"
                                    placeholder="Search 100+ millions of products"
                                    value={this.state.searchBarValue}
                                    onChange={this.handleChange}
                                    name="searchBarValue"
                                    className="nav-search nav-search-field"
                                    aria-expanded="true"
                                    style={{ color: "black" }}
                                  />
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <div
                                      className="btn-search"
                                      style={{
                                        width: "40px",
                                        position: "relative",
                                      }}
                                    >
                                      <i
                                        className="fa fa-camera"
                                        style={{
                                          color: "#ff4c3b",
                                          marginTop: 12,
                                          fontSize: "150%",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          window.document
                                            .getElementById(
                                              "upload-image-input11"
                                            )
                                            .click();
                                        }}
                                      />
                                    </div>
                                    <button
                                      type="submit"
                                      style={{
                                        position: "relative",
                                        backgroundColor: "#ff4c3b",
                                        minHeight: "100%",
                                        marginTop: -5,
                                        marginRight: -5,
                                        borderRadius: 0,
                                      }}
                                      onClick={this.handleSearchBarSubmit}
                                    >
                                      {this.state.imgLoading ? (
                                        <ClipLoader
                                          loading={this.state.imgLoading}
                                          color="white"
                                          size={20}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-search"
                                          style={{
                                            color: "white",
                                            margin: "auto",
                                            padding: "5px 13px",
                                            fontSize: "120%",
                                          }}
                                        />
                                      )}
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>

                            {this.state.prviewImage && this.state.imageUrl ? (
                              <div
                                className="row"
                                style={{
                                  paddingTop: 0,
                                  justifyContent: "center",
                                  marginLeft: 20,
                                  marginTop: 10,
                                  marginRight: 15,
                                }}
                              >
                                <div
                                  style={{
                                    padding: "5px 10px",
                                    fontWeight: "bold",
                                    fontSize: 14,
                                    color: "#ff4a4e",
                                    paddingLeft: 0,
                                  }}
                                >
                                  Showing{" "}
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "black",
                                    }}
                                  >
                                    {this.props.totalResults}
                                  </span>{" "}
                                  Result of{" "}
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "black",
                                    }}
                                  >
                                    {this.props.totalFound}
                                  </span>{" "}
                                  for{" "}
                                  <img
                                    src={this.state.prviewImage}
                                    style={{
                                      minHeight: 100,
                                      maxHeight: 100,
                                      minWidth: 100,
                                      maxWidth: 100,
                                      border: "2px solid gainsboro",
                                      borderRadius: 5,
                                    }}
                                  />
                                </div>
                              </div>
                            ) : this.state.shop_name ? (
                              <div
                                className="row"
                                style={{
                                  paddingTop: 0,
                                  justifyContent: "center",
                                  marginLeft: 20,
                                  marginTop: 10,
                                  marginRight: 15,
                                }}
                              >
                                <div
                                  style={{
                                    padding: "5px 10px",
                                    fontWeight: "bold",
                                    fontSize: 14,
                                    color: "#ff4a4e",
                                    paddingLeft: 0,
                                  }}
                                >
                                  Showing{" "}
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "black",
                                    }}
                                  >
                                    {this.props.totalResults}
                                  </span>{" "}
                                  Result of{" "}
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "black",
                                    }}
                                  >
                                    {this.props.totalFound}
                                  </span>{" "}
                                  for{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: 14,
                                      color: "black",
                                    }}
                                  >
                                    Shop Name: {this.state.shop_name}
                                  </span>
                                </div>
                              </div>
                            ) : this.state.categoryId ? null : (
                              <div
                                className="row"
                                style={{
                                  paddingTop: 0,
                                  justifyContent: "center",
                                  marginLeft: 20,
                                  marginTop: 10,
                                  marginRight: 15,
                                }}
                              >
                                <div
                                  style={{
                                    padding: "5px 10px",
                                    fontWeight: "bold",
                                    fontSize: 14,
                                    color: "#ff4a4e",
                                    paddingLeft: 0,
                                  }}
                                >
                                  Showing{" "}
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "black",
                                    }}
                                  >
                                    {this.props.totalResults}
                                  </span>{" "}
                                  result of{" "}
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "black",
                                    }}
                                  >
                                    {this.props.totalFound}
                                  </span>{" "}
                                  for{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: 14,
                                      color: "black",
                                    }}
                                  >
                                    {this.props.match.params.id}{" "}
                                  </span>
                                </div>
                              </div>
                            )}
                            {/* {this.state.categoryId == "Last" ||
                              this.state.categoryId == "Popular" ||
                              this.state.shop_name ? null : (
                                <div
                                  className="filter-container"
                                  style={{
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    marginTop: this.state.categoryId ? 10 : 0,
                                  }}
                                >
                                  <select
                                    title="Filter by category"
                                    required
                                    name="filterByCategory"
                                    className="custom-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={this.handleChange2}
                                    value={this.state.filterByCategory}
                                  >
                                    <option value="">Filter Products </option>
                                    <option value="Default">Default</option>
                                    <option value="sales-desc">
                                      Best Selling
                                    </option>
                                    <option value="price-asc">
                                      Low To High (price)
                                    </option>
                                    <option value="price-desc">
                                      High To Low (price)
                                    </option>
                                  </select>
                                </div>
                              )} */}

                            <div
                              className="product-wrapper-grid"
                              style={{ marginTop: 10 }}
                            >
                              <div className="container-fluid">
                                <div className="row">
                                  <ProductListing
                                    colSize={this.state.layoutColumns}
                                    {...this.props}
                                    shop={this.state.shop}
                                    imageUrl={this.state.imageUrl}
                                    filterByCategory={
                                      this.state.filterByCategory
                                    }
                                    active={this.state.active}
                                    setLoader={(value) => {
                                      this.setState({
                                        active: value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*Section End*/}
        <input
          id="upload-image-input11"
          className="upload"
          type="file"
          accept="image/*"
          ref={this.fileInputRef}
          style={{
            position: "absolute",
            zIndex: 5,
            maxWidth: "50px",
            marginTop: "10px",
            display: "none",
          }}
          onChange={this.handleImgChange}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    products: state.searchedProducts.products,
    symbol: state.data.symbol,
    totalResults: state.searchedProducts.totalResults,
    totalFound: state.searchedProducts.totalFound,
    currentUser: state.user.currentUser,
  };
};

export default connect(mapStateToProps, {
  emptySearchedProductsArray,
  setSearchedProductsArray,
})(CollectionNoSideBar);
